import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { createNagwaRenderEngineSlice } from "./slices/nagwaRenderEngineSlice";
import { createLiveSessionSlice } from "./slices/liveSessionSlice";
import { createToolbarPensSlice } from "./slices/toolbarPensSlice";
import { createToolbarActionsSlice } from "./slices/toolbarActionsSlice";
import { createLiveKitRoomSlice } from "./slices/liveKitRoomSlice";
import type { liveSessionStoreType } from "./types/liveSessionStoreType";


// Create the store with all slices
export const useLiveSessionStore = create<liveSessionStoreType>()(
  devtools<liveSessionStoreType>(
    (...a) => ({
      ...createNagwaRenderEngineSlice(...a),
      ...createLiveSessionSlice(...a),
      ...createToolbarPensSlice(...a),
      ...createToolbarActionsSlice(...a),
      ...createLiveKitRoomSlice(...a),
    }),
    {
      name: "liveSessionStore",
    }
  ) as any
);
